import type { SecondaryOrderStatePath } from 'state/secondaryMarket/secondaryMarket.model';
import { toValidationErrors } from 'state/secondaryMarket/shared/amend.utils';
import type { AmendErrorType, AmendedTrade } from 'state/secondaryMarket/shared/amend/amend.model';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { AppState } from 'state/state.model';
import type { LoadingStatus } from 'utils/status';

export const amendTradeSelectorsFactory = (stateType: SecondaryOrderStatePath) => {
  const getAmendState = (state: AppState, tabId: string): AmendedTrade | undefined => {
    return state.secondaryMarket[stateType].amend[tabId];
  };

  const getAmendedOrderStatus = (state: AppState, tabId: string): LoadingStatus => getAmendState(state, tabId)!.status;

  const getOrderValidationErrors = (state: AppState, tabId: string): SecondaryMarketFormError[] => {
    const validations = getAmendState(state, tabId)?.validations;
    return toValidationErrors(validations);
  };

  const getInnerErrorMessage = (state: AppState, tabId: string): string | undefined =>
    getAmendState(state, tabId)?.errorMessage;

  const getErrorType = (state: AppState, tabId: string): AmendErrorType | undefined =>
    getAmendState(state, tabId)?.errorType;

  const getErrorMessage = (state: AppState, tabId: string): string | undefined => {
    const errorMessage = getAmendState(state, tabId)?.errorMessage;
    const errorType = getAmendState(state, tabId)?.errorType;

    switch (errorType) {
      case 'rejected':
      case 'failed':
        return errorMessage !== undefined
          ? errorMessage
          : `secondaryMarket.sidePanel.amend.${stateType}.label.error.${errorType}`;
      case 'collided':
        return `secondaryMarket.sidePanel.amend.${stateType}.label.error.${errorType}`;
      default:
        return undefined;
    }
  };
  return {
    getAmendState,
    getAmendedOrderStatus,
    getErrorMessage,
    getInnerErrorMessage,
    getErrorType,
    getOrderValidationErrors,
  };
};

export type AmendSelectors = ReturnType<typeof amendTradeSelectorsFactory>;
